import React, { Suspense } from "react"
import { Spinner, Center } from "@chakra-ui/react"

const MarkdownEdit = React.lazy(
  () => import("./edit" /* webpackChunkName: "MarkdownEdit" */)
)

const MarkdownEditLazy = (props: any) => {
  return (
    <Suspense
      fallback={
        <Center>
          <Spinner />
        </Center>
      }
    >
      <MarkdownEdit {...props} />
    </Suspense>
  )
}

export default MarkdownEditLazy
